import { StorageManager } from '@speeki/storage-manager';

import { UserModulesDocument } from '@graphql/generated/graphql';

import { useQuery, useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

/**
 * cache-and-network is necessary for log out user on "UNAUTHENTICATED" error
 */
export const useUserModules = () => {
    const mfaMetadata = StorageManager.getValue('metadata');
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;

    return useQuery(UserModulesDocument, {
        context: {
            logoutOnError: true,
        },
        fetchPolicy: 'cache-and-network',
        skip: !isLoggedIn || !!mfaMetadata,
    });
};
